// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { heading4FontSize, body1LineHeight, screenSmMin, spacer8, spacer12, spacer20, spacer24, spacer32, spacer40, spacer80, Type } from '@spotify-internal/encore-web';
import { ContentfulImage } from '../../../Contentful/ContentfulImage';
import { Box, ImageAspectBox1x1 } from '../../../ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled(Box).withConfig({
  displayName: "HeroDescription__Wrapper",
  componentId: "sc-1pd4vv0-0"
})(["background-color:", ";color:", ";height:auto;&.tallest{height:100%;}"], function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textColor;
});
var HeroDescriptionWrapper = styled.div.withConfig({
  displayName: "HeroDescription__HeroDescriptionWrapper",
  componentId: "sc-1pd4vv0-1"
})(["padding-top:", ";display:flex;flex-direction:row;flex-wrap:wrap;justify-content:'flex-start';@media (max-width:", "){padding-top:0px;}"], spacer20, screenSmMin);
var HeroDescriptionWrapperNoImage = styled.div.withConfig({
  displayName: "HeroDescription__HeroDescriptionWrapperNoImage",
  componentId: "sc-1pd4vv0-2"
})(["height:100%;display:flex;flex-direction:column;flex-wrap:wrap;justify-content:", ";"], function (props) {
  return props.centered ? 'center' : 'flex-start';
});
var StyledText = styled.div.withConfig({
  displayName: "HeroDescription__StyledText",
  componentId: "sc-1pd4vv0-3"
})(["width:55%;padding-bottom:0;text-align:left;padding-left:", ";@media (max-width:", "){width:100%;padding-left:0px;padding-top:", ";}"], spacer80, screenSmMin, spacer8);
var StyledBody = styled.div.withConfig({
  displayName: "HeroDescription__StyledBody",
  componentId: "sc-1pd4vv0-4"
})(["display:flex;flex-direction:column;height:100%;justify-content:center;"]); // TODO Remove hardcoding of font-size and line-height for mobile

var DescriptionWrapper = styled(Type.p).attrs({
  variant: Type.heading2,
  weight: Type.book
}).withConfig({
  displayName: "HeroDescription__DescriptionWrapper",
  componentId: "sc-1pd4vv0-5"
})(["padding-bottom:0;@media (max-width:", "){width:100%;padding-left:0;font-size:", ";line-height:", ";}"], screenSmMin, heading4FontSize, body1LineHeight);
var DescriptionWrapperNoImage = styled(Type.p).attrs({
  variant: Type.heading2,
  weight: Type.book
}).withConfig({
  displayName: "HeroDescription__DescriptionWrapperNoImage",
  componentId: "sc-1pd4vv0-6"
})(["padding-bottom:0;text-align:center;align-self:center;max-width:867px;@media (max-width:", "){width:100%;padding-left:0;}@media (max-width:", "){font-size:", ";line-height:", ";}"], screenSmMin, screenSmMin, spacer24, spacer32);
var MaxWidth = styled.div.withConfig({
  displayName: "HeroDescription__MaxWidth",
  componentId: "sc-1pd4vv0-7"
})(["max-width:867px;", ";"], function (props) {
  return props.centered ? 'align-self: center; display: flex; flex-direction: column;' : '';
});
var ImageWrapper = styled(ImageAspectBox1x1).withConfig({
  displayName: "HeroDescription__ImageWrapper",
  componentId: "sc-1pd4vv0-8"
})(["width:30%;display:flex;align-items:center;height:fit-content;align-self:center;@media (max-width:", "){width:100%;margin-bottom:", ";}"], screenSmMin, spacer8);
var StyledSupertext = styled(Type).attrs({
  variant: Type.body1,
  weight: Type.bold
}).withConfig({
  displayName: "HeroDescription__StyledSupertext",
  componentId: "sc-1pd4vv0-9"
})(["padding-bottom:", ";text-transform:uppercase;@media (max-width:", "){padding-left:0;padding:", " 0px;width:100%;}"], spacer20, screenSmMin, spacer12);
var StyledSupertextNoImage = styled(Type).attrs({
  variant: Type.body1,
  weight: Type.bold
}).withConfig({
  displayName: "HeroDescription__StyledSupertextNoImage",
  componentId: "sc-1pd4vv0-10"
})(["padding:0;height:auto;align-self:center;text-align:center;text-transform:uppercase;padding-bottom:", ";@media (max-width:", "){padding-left:0;padding-top:", ";width:100%;}"], spacer40, screenSmMin, spacer8);
var BodyTextContainer = styled.div.withConfig({
  displayName: "HeroDescription__BodyTextContainer",
  componentId: "sc-1pd4vv0-11"
})(["height:100%;"]);
export var HeroDescription = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$supertext = _ref.supertext,
      supertext = _ref$supertext === void 0 ? '' : _ref$supertext,
      _ref$body = _ref.body,
      body = _ref$body === void 0 ? '' : _ref$body,
      image = _ref.image,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '' : _ref$backgroundColor,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? '' : _ref$textColor;
  var centered = image === undefined;
  return !centered ? /*#__PURE__*/_jsx(Wrapper, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    ref: ref,
    children: /*#__PURE__*/_jsxs(HeroDescriptionWrapper, {
      children: [image && /*#__PURE__*/_jsx(ImageWrapper, {
        children: /*#__PURE__*/_jsx(ContentfulImage, {
          asset: image
        })
      }), /*#__PURE__*/_jsx(StyledText, {
        children: /*#__PURE__*/_jsx(BodyTextContainer, {
          children: /*#__PURE__*/_jsxs(StyledBody, {
            children: [/*#__PURE__*/_jsx(StyledSupertext, {
              children: supertext
            }), /*#__PURE__*/_jsx(MaxWidth, {
              centered: centered,
              children: /*#__PURE__*/_jsx(DescriptionWrapper, {
                children: body
              })
            })]
          })
        })
      })]
    })
  }) : /*#__PURE__*/_jsx(Wrapper, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    ref: ref,
    children: /*#__PURE__*/_jsx(HeroDescriptionWrapperNoImage, {
      centered: centered,
      children: /*#__PURE__*/_jsxs(MaxWidth, {
        centered: centered,
        children: [/*#__PURE__*/_jsx(StyledSupertextNoImage, {
          children: supertext
        }), /*#__PURE__*/_jsx(DescriptionWrapperNoImage, {
          children: body
        })]
      })
    })
  });
});